/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Define el estado de la actividad.
 */
export type EstadoActividad = 'ACTIVO' | 'CANCELADO' | 'BORRADOR';

export const EstadoActividad = {
    ACTIVO: 'ACTIVO' as EstadoActividad,
    CANCELADO: 'CANCELADO' as EstadoActividad,
    BORRADOR: 'BORRADOR' as EstadoActividad
};

